/**
 * @Author: Zero
 * @Date: 2024-03-28 14:11:19
 * @Explain: 联系人 - lipass 预约邮件
 */

import http from '../http';

const MODEL = '/lipass-reserve';

const ignoreConvertedKey = [
  'subject_attributes_default_value',
  'subject_attributes_default_value',
  'attributes_default_value',
  'subjectAttributesDefaultValue',
  'attributesDefaultValue',
];
export default {
  // 获取lipass预约开始状态
  getLipassOpenStatus(data: Record<any, any>) {
    return http.post(`${MODEL}/get-switch`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 获取配置
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get-config`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 保存配置
  onSave(data: Record<any, any>) {
    return http.post(`${MODEL}/save-config`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(ignoreConvertedKey),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify(ignoreConvertedKey),
      },
    });
  },

  // 发送测试邮件
  onSendTestEmail(data: Record<any, any>) {
    return http.post(`${MODEL}/send-test-email`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'variable_pair',
          'variablePair',
          'subject_attributes_default_value',
          'attributes_default_value',
          'subjectAttributesDefaultValue',
          'attributesDefaultValue',
        ]),
      },
    });
  },
};
